import React from "react";

export const KPI = ({ label, value, sublabel, accent = "gold", testid }) => {
  const colorClass =
    accent === "critical" ? "text-[color:var(--auditiq-critical)]" :
    accent === "warning" ? "text-[color:var(--auditiq-warning)]" :
    accent === "success" ? "text-[color:var(--auditiq-success)]" : "text-gold";
  return (
    <div className="panel-elev p-6" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-[0.24em] text-steel">{label}</div>
      <div className={`metric text-4xl mt-3 ${colorClass}`}>{value}</div>
      {sublabel && <div className="text-xs text-cream-dim mt-2">{sublabel}</div>}
    </div>
  );
};

export default KPI;
